// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/Content/biolabicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/Content/biolabicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/Content/biolabicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/Content/biolabicons.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "biolabicons";
	font-display: block;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("embedded-opentype"),
url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}

.biolabicons {
	line-height: 1;
}

.biolabicons:before {
	font-family: biolabicons !important;
	font-style: normal;
	font-weight: normal !important;
	vertical-align: top;
}

.icon-add:before {
	content: "\\f101";
}
.icon-app:before {
	content: "\\f102";
}
.icon-appManagement:before {
	content: "\\f103";
}
.icon-backArrow:before {
	content: "\\f104";
}
.icon-calendar:before {
	content: "\\f105";
}
.icon-check:before {
	content: "\\f106";
}
.icon-checkbox_checked:before {
	content: "\\f107";
}
.icon-checkbox_empty:before {
	content: "\\f108";
}
.icon-close:before {
	content: "\\f109";
}
.icon-dashboard:before {
	content: "\\f10a";
}
.icon-dealerManagement:before {
	content: "\\f10b";
}
.icon-delete:before {
	content: "\\f10c";
}
.icon-down:before {
	content: "\\f10d";
}
.icon-downArrow:before {
	content: "\\f10e";
}
.icon-downBox:before {
	content: "\\f10f";
}
.icon-dragHandle:before {
	content: "\\f110";
}
.icon-edit:before {
	content: "\\f111";
}
.icon-error:before {
	content: "\\f112";
}
.icon-failed:before {
	content: "\\f113";
}
.icon-info:before {
	content: "\\f114";
}
.icon-language:before {
	content: "\\f115";
}
.icon-leftArrow:before {
	content: "\\f116";
}
.icon-leftDoubleArrow:before {
	content: "\\f117";
}
.icon-lock:before {
	content: "\\f118";
}
.icon-profile:before {
	content: "\\f119";
}
.icon-repsAdmin:before {
	content: "\\f11a";
}
.icon-repsCalendar:before {
	content: "\\f11b";
}
.icon-repsFailed:before {
	content: "\\f11c";
}
.icon-repsSuccess:before {
	content: "\\f11d";
}
.icon-resendEmail:before {
	content: "\\f11e";
}
.icon-rightArrow:before {
	content: "\\f11f";
}
.icon-rightCaret:before {
	content: "\\f120";
}
.icon-rightDoubleArrow:before {
	content: "\\f121";
}
.icon-roleManagement:before {
	content: "\\f122";
}
.icon-search:before {
	content: "\\f123";
}
.icon-successful:before {
	content: "\\f124";
}
.icon-unlock:before {
	content: "\\f125";
}
.icon-up:before {
	content: "\\f126";
}
.icon-upArrow:before {
	content: "\\f127";
}
.icon-upBox:before {
	content: "\\f128";
}
.icon-upload:before {
	content: "\\f129";
}
.icon-user_is_locked:before {
	content: "\\f12a";
}
.icon-userManagement:before {
	content: "\\f12b";
}
`, "",{"version":3,"sources":["webpack://./Javascript/components/Icon/icons/biolab-icons.font.js"],"names":[],"mappings":"AAAA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB;;;0DAGiD;AAClD;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["@font-face {\n\tfont-family: \"biolabicons\";\n\tfont-display: block;\n\tsrc: url(\"/Content/biolabicons.eot?#iefix\") format(\"embedded-opentype\"),\nurl(\"/Content/biolabicons.woff\") format(\"woff\"),\nurl(\"/Content/biolabicons.woff2\") format(\"woff2\"),\nurl(\"/Content/biolabicons.ttf\") format(\"truetype\");\n}\n\n.biolabicons {\n\tline-height: 1;\n}\n\n.biolabicons:before {\n\tfont-family: biolabicons !important;\n\tfont-style: normal;\n\tfont-weight: normal !important;\n\tvertical-align: top;\n}\n\n.icon-add:before {\n\tcontent: \"\\f101\";\n}\n.icon-app:before {\n\tcontent: \"\\f102\";\n}\n.icon-appManagement:before {\n\tcontent: \"\\f103\";\n}\n.icon-backArrow:before {\n\tcontent: \"\\f104\";\n}\n.icon-calendar:before {\n\tcontent: \"\\f105\";\n}\n.icon-check:before {\n\tcontent: \"\\f106\";\n}\n.icon-checkbox_checked:before {\n\tcontent: \"\\f107\";\n}\n.icon-checkbox_empty:before {\n\tcontent: \"\\f108\";\n}\n.icon-close:before {\n\tcontent: \"\\f109\";\n}\n.icon-dashboard:before {\n\tcontent: \"\\f10a\";\n}\n.icon-dealerManagement:before {\n\tcontent: \"\\f10b\";\n}\n.icon-delete:before {\n\tcontent: \"\\f10c\";\n}\n.icon-down:before {\n\tcontent: \"\\f10d\";\n}\n.icon-downArrow:before {\n\tcontent: \"\\f10e\";\n}\n.icon-downBox:before {\n\tcontent: \"\\f10f\";\n}\n.icon-dragHandle:before {\n\tcontent: \"\\f110\";\n}\n.icon-edit:before {\n\tcontent: \"\\f111\";\n}\n.icon-error:before {\n\tcontent: \"\\f112\";\n}\n.icon-failed:before {\n\tcontent: \"\\f113\";\n}\n.icon-info:before {\n\tcontent: \"\\f114\";\n}\n.icon-language:before {\n\tcontent: \"\\f115\";\n}\n.icon-leftArrow:before {\n\tcontent: \"\\f116\";\n}\n.icon-leftDoubleArrow:before {\n\tcontent: \"\\f117\";\n}\n.icon-lock:before {\n\tcontent: \"\\f118\";\n}\n.icon-profile:before {\n\tcontent: \"\\f119\";\n}\n.icon-repsAdmin:before {\n\tcontent: \"\\f11a\";\n}\n.icon-repsCalendar:before {\n\tcontent: \"\\f11b\";\n}\n.icon-repsFailed:before {\n\tcontent: \"\\f11c\";\n}\n.icon-repsSuccess:before {\n\tcontent: \"\\f11d\";\n}\n.icon-resendEmail:before {\n\tcontent: \"\\f11e\";\n}\n.icon-rightArrow:before {\n\tcontent: \"\\f11f\";\n}\n.icon-rightCaret:before {\n\tcontent: \"\\f120\";\n}\n.icon-rightDoubleArrow:before {\n\tcontent: \"\\f121\";\n}\n.icon-roleManagement:before {\n\tcontent: \"\\f122\";\n}\n.icon-search:before {\n\tcontent: \"\\f123\";\n}\n.icon-successful:before {\n\tcontent: \"\\f124\";\n}\n.icon-unlock:before {\n\tcontent: \"\\f125\";\n}\n.icon-up:before {\n\tcontent: \"\\f126\";\n}\n.icon-upArrow:before {\n\tcontent: \"\\f127\";\n}\n.icon-upBox:before {\n\tcontent: \"\\f128\";\n}\n.icon-upload:before {\n\tcontent: \"\\f129\";\n}\n.icon-user_is_locked:before {\n\tcontent: \"\\f12a\";\n}\n.icon-userManagement:before {\n\tcontent: \"\\f12b\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
